// Живой кадр shell.updated (В3) — плашка «перезагрузите вкладку».
import { useEffect, useState } from "react";
import { LIVE_FRAME_EVENT } from "../live";
import { sharedEventBus } from "../osnovaContext";
export function useShellUpdated() {
    const [shellUpdated, setShellUpdated] = useState(false);
    useEffect(() => sharedEventBus.on(`${LIVE_FRAME_EVENT}:shell.updated`, () => setShellUpdated(true)), []);
    return shellUpdated;
}
